const enrichedData = (data) =>
  data?.map((row) => {
    // Preserve the original influencer id, link, and created_at before spreading related table data
    const originalId = row.id;
    const originalLink = row.link;
    const originalCreatedAt = row.created_at;
    
    const enriched = {
      ...row,
      ...(Array.isArray(row.influencer_free_checks) ? row.influencer_free_checks[0] : row.influencer_free_checks ?? {}),
      ...(Array.isArray(row.influencer_paid_checks) ? row.influencer_paid_checks[0] : row.influencer_paid_checks ?? {}),
      ...(Array.isArray(row.internal_reviews) ? row.internal_reviews[0] : row.internal_reviews ?? {}),
    };
    
    // Restore original influencer id, link, and created_at (they might be overwritten by related table data)
    enriched.id = originalId;
    enriched.link = originalLink;
    enriched.created_at = originalCreatedAt;

    // Ensure language_german and audience_dach are present in the row
    enriched.language_german = row.influencer_paid_checks?.language_german ?? row.language_german ?? null;
    enriched.audience_dach = row.influencer_paid_checks?.audience_dach ?? row.audience_dach ?? null;

    // History data will be loaded on demand when row is expanded
    enriched.status_history = [];
    enriched.free_check_history = [];
    enriched.paid_check_history = [];

    // Free Check enrichment removed engagement data
    if (row.user_typeScore !== undefined) {
      enriched.quality_score = row.user_typeScore;
    }
    if (row.postArray && Array.isArray(row.postArray)) {
      const totalReach = row.postArray.reduce((acc, post) => acc + (post.reach || 0), 0);
      enriched.reach = totalReach;
    }
    if (row.posts !== undefined) {
      enriched.posts = row.posts;
    }
    if (row.followers !== undefined) {
      enriched.followers = row.followers;
    }

    // Paid Check enrichment
    if (row.influencer_paid_checks?.quality_score !== undefined) {
      enriched.quality_score = row.influencer_paid_checks.quality_score;
    }

    if (row.influencer_paid_checks?.sponsored_posts_percentage !== undefined) {
      enriched.sponsored_posts_percentage = row.influencer_paid_checks.sponsored_posts_percentage;
    }
    if (row.influencer_paid_checks?.sponsored_reels_percentage !== undefined) {
      enriched.sponsored_reels_percentage = row.influencer_paid_checks.sponsored_reels_percentage;
    }
    if (row.influencer_paid_checks?.posts_per_week !== undefined) {
      enriched.posts_per_week = row.influencer_paid_checks.posts_per_week;
    }
    if (row.influencer_paid_checks?.reels_per_week !== undefined) {
      enriched.reels_per_week = row.influencer_paid_checks.reels_per_week;
    }

    return enriched;
  });

export default enrichedData;
